.nest-button {
  &--primary {
    @apply text-center text-white outline-none
    border border-transparent
    bg-blue-600 hover:bg-blue-700 focus:ring-2;
  }

  &--secondary {
    @apply bg-blue-600 text-center outline-none focus:ring-2
    border border-transparent
    bg-secondary hover:border-gray-300
    text-secondary-foreground;
  }

  &--outline {
    @apply inline-flex items-center gap-x-2 rounded-lg
    bg-white hover:bg-blue-50
    border border-gray-200 hover:border-blue-600
    text-gray-500 hover:text-blue-600
    disabled:opacity-50 disabled:pointer-events-none;
  }


  &--link {
    @apply inline-flex items-center gap-x-2 text-sm font-semibold
    rounded-lg border border-transparent text-blue-600 hover:text-blue-800 disabled:opacity-50 disabled:pointer-events-none;
  }
}
